import { render, staticRenderFns } from "./EditPerDocumentStockSettings.vue?vue&type=template&id=6a047d58"
import script from "./EditPerDocumentStockSettings.vue?vue&type=script&lang=ts"
export * from "./EditPerDocumentStockSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a047d58')) {
      api.createRecord('6a047d58', component.options)
    } else {
      api.reload('6a047d58', component.options)
    }
    module.hot.accept("./EditPerDocumentStockSettings.vue?vue&type=template&id=6a047d58", function () {
      api.rerender('6a047d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/EditPerDocumentStockSettings.vue"
export default component.exports